(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lior-floating-delivery"] && !Shopify.designMode) return;
  try {
    (function () {
  const badge = document.querySelector('#lior-floating-delivery[data-order-delivery]');
  if (!badge) return;
  const holidays = new Set(JSON.parse(badge.querySelector('[data-delivery-holidays]').textContent));
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Jerusalem', year:'numeric', month:'2-digit', day:'2-digit' }).formatToParts(new Date());
  const values = Object.fromEntries(parts.map(p => [p.type,p.value]));
  const date = new Date(Date.UTC(Number(values.year),Number(values.month)-1,Number(values.day),12));
  if (date.getUTCFullYear() > 2031) return;
  let counted = 0;
  while (counted < 14) {
    date.setUTCDate(date.getUTCDate()+1);
    const weekday = date.getUTCDay();
    if (weekday !== 5 && weekday !== 6 && !holidays.has(date.toISOString().slice(0,10))) counted++;
  }
  const label = new Intl.DateTimeFormat('he-IL',{day:'numeric',month:'long',timeZone:'UTC'}).format(date);
  badge.querySelector('[data-delivery-date]').textContent = badge.dataset.dateLabel + ' ' + label;
})();
  } catch(e) { console.error(e); }
})();

})();
